export default function getResource(label, vars = []) {
    const resources = {
        widgetError: `Difficulté à se connecter à ${vars[0]}. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.`,
        legalNotice: `En cliquant sur « Continuer vers ${vars[0]} », je demande à Sephora \
d’envoyer les renseignements de la commande et de facturation à Afterpay et je comprend que \
ces renseignements sont assujettis aux \
<a href='${vars[1]}' target='_blank'>modalités</a> et à la \
<a href='${vars[2]}' target='_blank'>politique de confidentialité</a> d’Afterpay.`
    };

    return resources[label];
}
